<template>
    <base-dialog :loading="loading" :value="dialog" :width="400" :title="$t('common.select_reason')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="ld-body">
            <div class="ld-reasons">
                <button v-for="reason in reasonsOptions" :key="reason.value" type="button" class="ld-reason"
                    :class="{ active: isActiveReason(reason.value) }" @click="currentReason = reason.value">
                    <v-icon size="22" :color="isActiveReason(reason.value) ? 'accent' : 'txtMuted'" v-text="reason.icon" />
                    <span>{{ reason.name }}</span>
                </button>
            </div>
            <div class="ld-picker-label">{{ $t('common.select_days_lock') }}</div>
            <v-date-picker v-model="dates" no-title :locale="datePickerLocale" :first-day-of-week="weekStartDay"
                :show-current="false" multiple :weekday-format="getDayString" color="primary" full-width
                class="ld-picker" />
        </div>

        <template v-slot:footer>
            <v-btn block depressed x-large color="primary" class="footer-btn black--text" :loading="loading"
                @click="lockDays">
                {{ $t('common.save_changes') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>

import {db} from "@/utils/Firebase";

import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "LockDaysDialog",
    components: { BaseDialog },
    props: {
        student: {
            type: Object,
            default: null,
        },
        currentLockDays: {
            type: Array,
            default: null,
        },
    },
    data(vm) {
        return {
            dialog: false,
            loading: false,
            days: [
                vm.$t('days.short_monday'),
                vm.$t('days.short_tuesday'),
                vm.$t('days.short_wednesday'),
                vm.$t('days.short_thursday'),
                vm.$t('days.short_friday'),
                vm.$t('days.short_saturday'),
                vm.$t('days.short_sunday'),
            ],
            reasonsOptions: [
                {name: vm.$t('common.injury'), value: 'injury', icon: '$injury'},
                {name: vm.$t('common.vacations'), value: 'vacations', icon: '$vacations'},
                {name: vm.$t('common.other'), value: 'other', icon: '$injury'},
            ],
            currentReason: null,
            dates: [],
        }
    },
    computed: {
    },
    methods: {
        show(dates) {
            const vm = this
            vm.dates = [...dates]
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.dates = []
            vm.currentReason = null
        },
        getDayString(date) {
            const vm = this
            return vm.days[vm.$moment(date).weekday()]
        },
        isActiveReason(reason) {
            const vm = this
            return vm.currentReason === reason
        },
        async lockDays() {
            const vm = this
            if (!vm.currentReason || vm.dates.length === 0 || !vm.student) return vm.toast(vm.$t('common.fields_incomplete'), 'error')

            await vm.withLoading(async () => {
                let currentLockDays = vm.currentLockDays.map(day => (day.date))
                let dates = vm.dates.filter(date => !currentLockDays.includes(date))

                for(let date of dates) {
                    await db.collection('lockDays').add({
                        coachId: vm.currentUser.uid,
                        studentId: vm.student.objectID,
                        reason: vm.currentReason,
                        date: date,
                    })
                }

                vm.toast(vm.$t('common.lock_days_successful'))
                vm.hide()
            })
        },
    },

}
</script>

<style scoped>
.ld-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.ld-reasons {
    display: flex;
    gap: 8px;
}

.ld-reason {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 6px;
    border-radius: 10px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    color: var(--v-txtSecondary-base);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color .15s, background .15s, color .15s;
}

.ld-reason.active {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, 0.12);
    color: var(--v-accent-base);
}

.ld-picker-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    padding-top: 14px;
    border-top: 1px solid var(--v-outline-base);
}

.ld-picker {
    background: transparent !important;
    box-shadow: none !important;
}

.ld-picker >>> .v-picker__body,
.ld-picker >>> .v-date-picker-table {
    background: transparent !important;
}

.ld-picker >>> .v-date-picker-header {
    display: none;
}

.ld-picker >>> .v-date-picker-table .v-btn {
    color: var(--v-txtPrimary-base);
}

.ld-picker >>> .v-date-picker-table .v-btn.v-btn--active {
    color: #0C0E12 !important;
}

.ld-picker >>> .v-date-picker-table th {
    color: var(--v-txtMuted-base);
}

.ld-picker >>> .v-date-picker-table .v-btn:not(.v-btn--active):hover {
    background: var(--v-surface2-base) !important;
}

.footer-btn {
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
}
</style>